import script from "./DocumentSubject.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentSubject.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentSubject.vue?vue&type=style&index=0&id=38e818fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e818fa"]])

export default __exports__